// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.FB_CONFIG_APIKEY,
  authDomain: process.env.FB_CONFIG_AUTHDOMAIN,
  databaseURL: process.env.FB_CONFIG_DATABASEURL,
  projectId: process.env.FB_CONFIG_PROJECTID,
  storageBucket: process.env.FB_CONFIG_STORAGEBUCKET,
  messagingSenderId: process.env.FB_CONFIG_MESSAGINGSENDERID,
};

export default firebaseConfig;
